import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import HomeScreen from "../src/screens/HomeScreen";
import SortingScreen from "./screens/Sorting/SortingScreen";
// import PathScreen from "./screens/PathFinding/PathScreen";
// import GraphScreen from "./screens/Graph/GraphScreen";
import FooterComponent from "./components/FooterComponent";
import DecisionTreeScreen from "./screens/ML/DecisionTreeScreen";
import HeaderComponent from "./components/HeaderComponent";
// import ArraysScreen from "./screens/Arrays/ArraysScreen";
// import BackTrackingScreen from "./screens/BackTracking/BackTrackingScreen";
// import StackScreen from "./screens/Stack/StackScreen";
// import QueueScreen from "./screens/Queue/QueueScreen";
// import LinkedListScreen from "./screens/LinkedList/LinkedListScreen";
// import AnnouncementComponent from "./components/AnnouncementComponent";

const App: React.FC = () => {
  useEffect(() => {}, []);
  return (
    <div className="App">
      {/* <AnnouncementComponent/> */}
      <HeaderComponent/>
      <BrowserRouter>
        <Switch>
          {/* <Route path="/" exact component={SortingScreen} /> */}
          <Route path="/" exact component={SortingScreen} />
          <Route path="/sorting" component={SortingScreen} />
          <Route path="/decisionTree" component={DecisionTreeScreen} />
          {/* <Route path="/arrays" component={ArraysScreen} />
          <Route path="/backtracking" component={BackTrackingScreen} />
          <Route path="/graph" component={GraphScreen} />
          <Route path="/stack" component={StackScreen} />
          <Route path="/queue" component={QueueScreen} />
          <Route path="/linkedList" component={LinkedListScreen} />
          <Route path="/pathFinding" component={PathScreen} /> */}
        </Switch>
        <FooterComponent />
      </BrowserRouter>
    </div>
  );
};

export default App;
